var _path, _path2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5614 28.3494L2.71949 53.3093L3.43877 54.004L30 28.3494L29.2807 27.6547L2.71948 2.00013L2.00021 2.69486L28.5614 28.3494Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71949 53.3093L1.6774 52.2304C1.38476 52.513 1.21949 52.9024 1.21949 53.3093C1.21949 53.7162 1.38476 54.1056 1.6774 54.3882L2.71949 53.3093ZM28.5614 28.3494L29.6035 29.4284C29.8962 29.1457 30.0614 28.7563 30.0614 28.3494C30.0614 27.9426 29.8962 27.5532 29.6035 27.2705L28.5614 28.3494ZM3.43877 54.004L2.39668 55.0829C2.97797 55.6444 3.89956 55.6444 4.48085 55.0829L3.43877 54.004ZM30 28.3494L31.0421 29.4284C31.3347 29.1457 31.5 28.7563 31.5 28.3494C31.5 27.9426 31.3347 27.5532 31.0421 27.2705L30 28.3494ZM29.2807 27.6547L30.3228 26.5758L30.3228 26.5758L29.2807 27.6547ZM2.71948 2.00013L3.76157 0.921218C3.18028 0.35977 2.25869 0.35977 1.6774 0.921218L2.71948 2.00013ZM2.00021 2.69486L0.958121 1.61594C0.665479 1.8986 0.500208 2.288 0.500208 2.69486C0.500208 3.10171 0.665479 3.49112 0.958122 3.77377L2.00021 2.69486ZM3.76158 54.3882L29.6035 29.4284L27.5194 27.2705L1.6774 52.2304L3.76158 54.3882ZM4.48085 52.9251L3.76158 52.2304L1.6774 54.3882L2.39668 55.0829L4.48085 52.9251ZM28.9579 27.2705L2.39668 52.9251L4.48085 55.0829L31.0421 29.4284L28.9579 27.2705ZM28.2386 28.7336L28.9579 29.4284L31.0421 27.2705L30.3228 26.5758L28.2386 28.7336ZM1.6774 3.07905L28.2386 28.7336L30.3228 26.5758L3.76157 0.921218L1.6774 3.07905ZM3.0423 3.77377L3.76157 3.07905L1.6774 0.921218L0.958121 1.61594L3.0423 3.77377ZM29.6035 27.2705L3.04229 1.61594L0.958122 3.77377L27.5194 29.4284L29.6035 27.2705Z",
    fill: "current"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3580e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8579f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b578ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.26818ab114ebf748802aea16415ba94c.svg";
export { ForwardRef as ReactComponent };